import { create } from 'zustand';

/**
 * WebSocket / real-time connection state.
 * Tracks connection status and recent events for the back-office dashboard.
 * The actual Socket.IO client is managed in src/lib/socket.js and
 * updates this store on connect/disconnect/events.
 */

const MAX_EVENTS = 50;

export const useRealtimeStore = create((set, get) => ({
  /** @type {'disconnected' | 'connecting' | 'connected'} */
  status: 'disconnected',

  /** The venue room currently joined */
  currentRoom: null,

  /** Rolling buffer of recent real-time events (newest first) */
  events: [],

  /** Last time we received any event */
  lastEventAt: null,

  // Actions
  setStatus: (status) => set({ status }),
  setRoom: (currentRoom) => set({ currentRoom }),

  /**
   * Push a new event into the buffer.
   * @param {string} type - Event type (e.g. 'sale:closed', 'alert:new')
   * @param {object} payload - Event payload from server
   */
  pushEvent: (type, payload) =>
    set((state) => ({
      lastEventAt: Date.now(),
      events: [
        { type, payload, receivedAt: Date.now() },
        ...state.events.slice(0, MAX_EVENTS - 1),
      ],
    })),

  clearEvents: () => set({ events: [], lastEventAt: null }),

  /**
   * Reset everything on disconnect or venue change.
   */
  reset: () =>
    set({
      status: 'disconnected',
      currentRoom: null,
      events: [],
      lastEventAt: null,
    }),
}));
